import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/modules/shared/ui/components/custom/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/modules/shared/ui/components/card";
import BillingPlans from "../components/BillingPlans";

export function ChangePlanPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-muted py-8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Back Button */}
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center gap-2 text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Subscription
        </Button>

        {/* Header Card */}
        <Card className="mb-8 rounded-2xl border border-border shadow-lg bg-card">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl font-bold text-foreground">
              Change Your Plan
            </CardTitle>
            <CardDescription className="text-base text-muted-foreground mt-2">
              Select a new plan that better fits your needs. Changes will take
              effect at the start of your next billing cycle.
            </CardDescription>
          </CardHeader>
        </Card>

        {/* Billing Plans - handles everything internally */}
        <BillingPlans />

        {/* Info Card */}
        <Card className="mt-8 rounded-2xl border border-blue-100 bg-blue-50">
          <CardContent className="pt-6">
            <div className="text-sm text-blue-900">
              <p className="font-semibold mb-2">Important Information:</p>
              <ul className="space-y-1 list-disc list-inside text-blue-800">
                <li>
                  Plan changes take effect at the start of your next billing
                  cycle
                </li>
                <li>You'll be charged the prorated amount for any upgrade</li>
                <li>Downgrades will apply a credit to your next invoice</li>
                <li>
                  Your current trial period (if applicable) will not be affected
                </li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}